import chatModule from '../chatModule';

const notificationsName = {
  CommunicationChannelsNotifications: 'CommunicationChannels',
  ChatMigrationNotifications: 'ChatMigration',
  ChatModerationTypeEligibilityNotifications: 'ChatModerationTypeEligibility',
  ChatNotifications: 'ChatNotifications',
  FriendshipNotifications: 'FriendshipNotifications',
  PresenceNotifications: 'PresenceNotifications',
  ChatPrivacySettingNotifications: 'ChatPrivacySettingNotifications',
  UserTagNotifications: 'UserTagChangeNotification',
  VoiceNotifications: 'VoiceNotifications'
};

chatModule.constant('notificationsName', notificationsName);

export default notificationsName;
